(() => {
  const onReady = (root = document) => {
    root.querySelectorAll('[data-peeey-slider]').forEach((slider) => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const slides = [...slider.querySelectorAll('[data-slide]')];
      let index = 0;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
      };
      slider.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
      slider.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
      show(0);
      const delay = Number(slider.dataset.autoplay || 0);
      if (delay > 0 && slides.length > 1) setInterval(() => show(index + 1), delay * 1000);
    });
    root.querySelectorAll('[data-peeey-tabs]').forEach((tabs) => {
      tabs.querySelectorAll('[data-tab]').forEach((button) => button.addEventListener('click', () => {
        const key = button.dataset.tab;
        tabs.querySelectorAll('[data-tab]').forEach((item) => item.classList.toggle('is-active', item === button));
        tabs.querySelectorAll('[data-panel]').forEach((panel) => panel.hidden = panel.dataset.panel !== key);
      }));
    });
    root.querySelectorAll('[data-countdown]').forEach((clock) => {
      const end = new Date(clock.dataset.countdown).getTime();
      const tick = () => {
        const diff = Math.max(0, end - Date.now());
        const days = Math.floor(diff / 86400000), hours = Math.floor(diff / 3600000) % 24, minutes = Math.floor(diff / 60000) % 60, seconds = Math.floor(diff / 1000) % 60;
        clock.innerHTML = `<span><b>${days}</b>gün</span><span><b>${hours}</b>saat</span><span><b>${minutes}</b>dakika</span><span><b>${seconds}</b>saniye</span>`;
      };
      tick(); setInterval(tick, 1000);
    });
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      entry.target.querySelectorAll('[data-counter]').forEach((el) => {
        const target = Number(el.dataset.counter || 0), start = performance.now(), duration = 1400;
        const frame = (now) => { const progress = Math.min(1, (now - start) / duration); el.textContent = Math.floor(target * progress).toLocaleString(); if (progress < 1) requestAnimationFrame(frame); };
        requestAnimationFrame(frame);
      });
      observer.unobserve(entry.target);
    }), { threshold: .15 });
    root.querySelectorAll('.peeey-reveal').forEach((el) => observer.observe(el));
    root.querySelectorAll('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      const open = menu.classList.toggle('is-open'); button.setAttribute('aria-expanded', String(open));
    }));
  };
  document.addEventListener('DOMContentLoaded', () => onReady());
  document.addEventListener('shopify:section:load', (event) => onReady(event.target));
})();
